/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanityContractListRequest = {
    term?: string;
    sortField?: HumanityContractListRequest.sortField;
    sortDirection?: HumanityContractListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace HumanityContractListRequest {

    export enum sortField {
        TRX_COUNT = 'TRX_COUNT',
        VERIFIED_AT = 'VERIFIED_AT',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

